import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./styles/nira-theme.css"
import { PostHogProvider } from "@posthog/react"
import { AppProviders } from "@/providers"
import { env } from "@/lib/env"
import { initAnalyticsContext, scrubUrls, POSTHOG_PRIVACY_OPTIONS } from "@/lib/analytics"
import { applyTheme } from "@/features/nira2/answer/hooks"
import { App } from "./app"
import "./globals.css"
import "./styles/na-shell.css"

// One theme for every route: the reader's choice, or light (nira.theme).
applyTheme()

const rootEl = document.getElementById("root")
if (!rootEl) throw new Error("No #root element found in index.html")

const app = (
  <AppProviders>
    <App />
  </AppProviders>
)

const token = env.VITE_POSTHOG_PROJECT_TOKEN
if (token) {
  // PostHogProvider initialises posthog-js on first render; super properties are registered once it is loaded.
  const host = env.VITE_POSTHOG_HOST || undefined
  createRoot(rootEl).render(
    <StrictMode>
      <PostHogProvider
        apiKey={token}
        options={{
          api_host: host,
          ...POSTHOG_PRIVACY_OPTIONS,
          before_send: scrubUrls,
          loaded: () => initAnalyticsContext(),
        }}
      >
        {app}
      </PostHogProvider>
    </StrictMode>
  )
} else {
  createRoot(rootEl).render(<StrictMode>{app}</StrictMode>)
}
